<template>

  <modal
    name="modal-component"
    classes="demo-modal-class"
    :min-width="200"
    :min-height="200"
    :scrollable="true"
    :reset="true"
    :adaptive="true"
    :draggable="true"
    width="65%"
    height="auto"
    @before-open="beforeOpen"
  >
      <ModalSiloImg :id="detailsId" :siteId="detailsSiteId"
                  :date="new Date(detailsDate)" :silo-name="detailssiloName" :siloColor="siloColor" :siloType="detailsType" :siteName="detailsSiteName" 
                  v-on:close="close" />

  </modal>

</template>

<script>

import ModalSiloImg from "./ModalSiloImg";

export default {
    name: 'ModalComponent',
    components: {
        //DemoCustomComponent
        //siloImg
        ModalSiloImg
    },
    
    data() {
        return {
            detailsId: undefined,
            detailsSiteId: undefined,
            detailsDate: undefined,
            detailssiloName: undefined,
            siloColor: undefined,
            detailsType: undefined,
            detailsSiteName: undefined,
        }
    },
    methods: {
        beforeOpen(event) {
            //console.log('before-open', event.params.text1,event.params.text2 );
            this.detailsId =  event.params.siloid;
            this.detailsSiteId = event.params.siteid;
            this.detailsDate = event.params.date;
            this.detailssiloName = event.params.siloname;
            this.siloColor =  event.params.silocolor;
            this.detailsType =  event.params.silotype;
            this.detailsSiteName = event.params.siteName;                  

        },
        close()
        {
          this.$modal.hide('modal-component')
        }
    }
}
</script>
